import React from "react";
import {
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightAddon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";

const UserTableControls = ({
  search,
  data=[],
  onSearchChange,
  sortOptions = [],
  onSortChange,
  filterButtonRef,
  onFilterOpen,
  showFilter = false,
  children,
}) => {
  return (
    <div className="flex flex-wrap justify-end items-center gap-2">
      {children}

      <div className="w-full sm:w-96">
        <InputGroup borderRadius={5} size="sm">
          <InputLeftElement pointerEvents="none" />
          <Input
            type="text"
            placeholder="Search..."
            border="1px solid #949494"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <InputRightAddon p={0} border="none">
            <Button
              className="bg-purple"
              colorScheme="#FF782D"
              size="sm"
              borderLeftRadius={0}
              borderRightRadius={3.3}
              border="1px solid #949494"
            >
              Search
            </Button>
          </InputRightAddon>
        </InputGroup>
      </div>

      {sortOptions.length > 0 && (
        <Menu>
          <MenuButton
            as={Button}
            colorScheme="#FF782D"
            zIndex={20}
            className="bg-bgBlue"
          >
            Sort By
          </MenuButton>
          <MenuList zIndex={20}>
            {sortOptions.map((option) => (
              <MenuItem
                key={option.value}
                onClick={() => onSortChange(option.value)}
              >
                {option.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      )}

      {showFilter && (
        <Menu>
          <MenuButton
            as={Button}
            colorScheme="#FF782D"
            zIndex={20}
            className="bg-purple"
            ref={filterButtonRef}
            onClick={onFilterOpen}
          >
            Filter By
          </MenuButton>
        </Menu>
      )}
    </div>
  );
};

export default UserTableControls;
